import { FUEL_TYPE, TITLE_STATUS, VEHICLE_TYPE } from "../fees/contants";

export const generateFeesReport = (feesFormData, response) => {
  const keys = Object.keys(response);
  const printableKeys = keys.filter((key) => !["Inputs", "Notes", "Type", "TransactionID"].includes(key));
  let index = 0;
  let dynamicFields = [];

  for (let i = 0; i < Math.ceil(printableKeys.length / 2); i++) {
    dynamicFields += `
      <div class="flex flex-col w-[100%] text-gray-700 gap-2">
        <div class="flex flex-row justify-between">
          <div>${printableKeys[index]}</div>
          <div class="font-medium">${response[printableKeys[index]]}</div>
        </div>
        ${
          index + 1 < printableKeys.length? `
            <div class="flex flex-row justify-between">
              <div>${printableKeys[index + 1]}</div>
              <div class="font-medium">${response[printableKeys[index + 1]]}</div>
            </div>
          ` : ""
        }
      </div>
    `;
    index += 2;
  }

  return (
    `<div class="default-bg-color p-6">
      <div class="flex flex-col gap-4 w-full">
        <div class="flex flex-row text-gray-700 font-bold mb-2 items-center h-11">
          Your Information
        </div>

        <div class="bg-white p-6 rounded-xl text-sm border border-gray-300">
          <div class="text-gray-700 mb-3 font-medium">Location Information</div>
          <div class="flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6">
            <div class="flex flex-col w-full text-gray-700 gap-2">
              ${feesFormData?.zipCode ? `
                <div class="flex flex-row justify-between">
                  <div>Zip Code:</div>
                  <div class="font-medium">${feesFormData.zipCode}</div>
                </div>
              ` : ""}

              ${feesFormData?.city ? `
                <div class="flex flex-row justify-between">
                  <div>City:</div>
                  <div class="font-medium">${feesFormData.city}</div>
                </div>
              ` : ""}

              <div class="flex flex-row justify-between">
                <div>Outside city limits:</div>
                <div class="font-medium">${feesFormData.outSideCityLimit ? "Yes" : "No"}</div>
              </div>
            </div>

            <div class="flex flex-col w-full text-gray-700 gap-2">
              ${feesFormData?.state ? `
                <div class="flex flex-row justify-between">
                  <div>State:</div>
                  <div class="font-medium">${feesFormData.state}</div>
                </div>
              ` : ""}

              ${feesFormData?.country ? `
                <div class="flex flex-row justify-between">
                  <div>County:</div>
                  <div class="font-medium">${feesFormData.country}</div>
                </div>
              ` : ""}
            </div>
          </div>

          <div class="border-t-2 border-t-gray-100 mb-3"></div>
          <div class="text-gray-700 mt-6 font-bold mb-3">
            Vehicle Information
            ${feesFormData?.vinCode ? `
              <span class="text-xs text-gray-600 font-normal ml-1">${feesFormData.vinCode}</span>
            ` : ""}
          </div>

          <div class="flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6">
            <div class="flex flex-col w-full text-gray-700 gap-2">
              ${feesFormData?.vehicleType ? `
                <div class="flex flex-row justify-between">
                  <div>Vehicle Type:</div>
                  <div class="font-medium">${VEHICLE_TYPE[feesFormData.vehicleType]}</div>
                </div>
              ` : ""}

              ${feesFormData?.fuelType ? `
                <div class="flex flex-row justify-between">
                  <div>Fuel Type:</div>
                  <div class="font-medium">${FUEL_TYPE[feesFormData.fuelType]}</div>
                </div>
              ` : ""}

              ${feesFormData?.msrp ? `
                <div class="flex flex-row justify-between">
                  <div>MSRP:</div>
                  <div class="font-medium">
                    ${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(feesFormData.msrp)}
                  </div>
                </div>
              ` : ""}
            </div>

            <div class="flex flex-col w-full text-gray-700 gap-2">
              ${feesFormData?.modelYear ? `
                <div class="flex flex-row justify-between">
                  <div>Model Year:</div>
                  <div class="font-medium">${feesFormData.modelYear}</div>
                </div>
              ` : ""}

              ${feesFormData?.vehicleWeight ? `
                <div class="flex flex-row justify-between">
                  <div>Vehicle Weight:</div>
                  <div class="font-medium">${Number(feesFormData?.vehicleWeight).toLocaleString()} lbs</div>
                </div>
              ` : ""}

              ${feesFormData?.gvw ? `
                <div class="flex flex-row justify-between">
                  <div>GVW:</div>
                  <div class="font-medium">${Number(feesFormData?.gvw).toLocaleString()} lbs</div>
                </div>
              ` : ""}

              ${feesFormData?.cityMpg !== '' && feesFormData?.cityMpg != null ? `
                <div class="flex flex-row justify-between">
                  <div>MPG (City):</div>
                  <div class="font-medium">${feesFormData.cityMpg}</div>
                </div>
              ` : ""}

              ${feesFormData?.highwayMpg !== '' && feesFormData?.highwayMpg != null ? `
                <div class="flex flex-row justify-between">
                  <div>Highway MPG:</div>
                  <div class="font-medium">${feesFormData.highwayMpg}</div>
                </div>
              ` : ""}

              ${feesFormData?.combinedMpg !== '' && feesFormData?.combinedMpg != null ? `
                <div class="flex flex-row justify-between">
                  <div>Combined MPG:</div>
                  <div class="font-medium">${feesFormData.combinedMpg}</div>
                </div>
              ` : ""}
            </div>
          </div>

          <div class="border-t-2 border-t-gray-100 mb-3"></div>
          <div class="text-gray-700 mt-6 font-bold mb-3">Transaction Information</div>

          <div class="flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6">
            <div class="flex flex-col w-full text-gray-700 gap-2">
              ${feesFormData?.basePrice ? `
                <div class="flex flex-row justify-between">
                  <div>Base Price:</div>
                  <div class="font-medium">${new Intl.NumberFormat('en-US', { 
                      style: 'currency', 
                      currency: 'USD' 
                    }).format(feesFormData.basePrice)}
                  </div>
                </div>
              ` : ""}

              ${feesFormData?.transactionType ? `
                <div class="flex flex-row justify-between">
                  <div>Transaction Type:</div>
                  <div class="font-medium">${feesFormData?.transactionType}</div>
                </div>
              ` : ""}


              <div class="flex flex-row justify-between">
                <div>Plate Transfer:</div>
                <div class="font-medium">${feesFormData?.plateTransfer ? "Yes" : "No"}</div>
              </div>
            </div>

            <div class="flex flex-col w-full text-gray-700 gap-2">
              ${feesFormData?.plateType ? `
                <div class="flex flex-row justify-between">
                  <div>Plate Type:</div>
                  <div class="font-medium">${feesFormData?.plateType}</div>
                </div>
              ` : ""}

              ${feesFormData?.titleStatus ? `
                <div class="flex flex-row justify-between">
                  <div>Title Status:</div>
                  <div class="font-medium">${TITLE_STATUS[feesFormData?.titleStatus]}</div>
                </div>
              ` : ""}
            </div>
          </div>
        </div>
      </div>

      <div class="mt-3">
        <div class='flex flex-col w-full'>
          <div class='flex flex-col gap-4 w-full'>
            <div class='flex flex-row justify-between mb-4 items-center'>
              <div class='text-gray-700 font-bold'>
                Fees Output
              </div>
            </div>
          </div>

          <div class='bg-white p-6 rounded-xl text-sm mb-4 mt-4 border border-gray-300'>
            <div class='text-gray-700 mb-3 font-medium'>
              Fee Output
            </div>

            <div class='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-2'>
              ${dynamicFields}
            </div>

            <div class='flex flex-col w-full text-gray-700 gap-2'>
              ${response["TransactionID"] &&
                `
                <div class='flex flex-col sm:flex-row justify-between break-words gap-1'>
                  <div>
                    Transaction ID:
                  </div>
                  <div class='font-medium max-w-full break-all text-right sm:text-left'>
                    ${response["TransactionID"]}
                  </div>
                </div>
                `
              }
            </div>
          </div>

          ${response["Notes"] &&
            `<div class="bg-white p-6 rounded-xl text-sm border border-gray-300">
              <div class="mb-2 text-gray-700">Notes</div>
              <div class="text-gray-600 text-xs">
                ${response["Notes"].split('|').map((note) => {
                    // Clean the incoming HTML (handle links so they open in a new tab when clicked)
                    const cleanNote = note ? note.replaceAll('<a ', '<a target="_blank" ') : '';

                    // Skip empty notes so we don't render a floating bullet
                    const textOnly = cleanNote.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim();
                    if (!textOnly.length) return "";

                    // Manually render the bullet in a flex row so html2canvas renders them properly
                    return `
                      <div style="display: flex; align-items: flex-start; margin-bottom: 4px;">
                        <span style="margin-right: 8px; flex-shrink: 0; font-weight: bold;">•</span>
                        <div class="sanitizedHtml" style="flex: 1;">${cleanNote.trim()}</div>
                      </div>
                    `;
                  }).join("")}
              </div>
            </div>`
          }
        </div>
      </div>
    </div>`
  )
}